export const SET_LANG = 'SET_LANG';
export const SET_HEADER_COLOR = 'SET_HEADER_COLOR';
export const SET_IS_OFFER_OPEN = 'SET_IS_OFFER_OPEN';
export const SET_IS_ESTIMATE_MENU_OPEN = 'SET_IS_ESTIMATE_MENU_OPEN';
export const SET_IS_MENU_OPEN = 'SET_IS_MENU_OPEN';
export const SET_ESTIMATE_DATA = 'SET_ESTIMATE_DATA';
